import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityLogService {
  constructor(private http: HttpClient) {}

  getUsers(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/users`);
  }

  getLogUserExecution(params: {
    userId?: string;
    startDate: string;
    endDate: string;
    page: number;
    pageSize: number;
    type?: string;
  }): Observable<any> {
    let qp = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('page', params.page)
      .set('pageSize', params.pageSize);

    if (params.userId) qp = qp.set('userId', params.userId);
    if (params.type) qp = qp.set('type', params.type);

    return this.http.get<any>(`${environment.apiUrl}/logUserExecution`, { params: qp });
  }
}